/** 日营业汇总页首次加载时默认隐藏的列。 */
export const DEFAULT_HIDDEN_BUSINESS_SUMMARY_COLUMN_IDS = [
    'eat_in_order_total',
    'take_out_order_total',
] as const;

/**
 * 根据所有可用列生成首次进入日营业汇总页时的可见列。
 * @param columnIds - 当前表格全部列的唯一标识
 * @returns 默认可见的列标识，保留原始顺序
 */
export function getInitialBusinessSummaryColumnIds(columnIds: string[]): string[] {
    const hiddenColumnIds = new Set<string>(DEFAULT_HIDDEN_BUSINESS_SUMMARY_COLUMN_IDS);
    return columnIds.filter((columnId) => !hiddenColumnIds.has(columnId));
}
